import { createServiceFactory } from '@/services/factory'
import { createMockSecurityPolicyService } from './securityPolicy.mock'
import { createHttpSecurityPolicyService } from './securityPolicy.http'

export type { SecurityPolicyService } from './securityPolicy.service'

export const getSecurityPolicyService = createServiceFactory(
  'securityPolicy',
  createMockSecurityPolicyService,
  createHttpSecurityPolicyService
)
